import graphql__54a9531d6ca6788b5c24 from "./__generated__/ToggleContributionAnonymousModeMutation.graphql.js";import { commitMutation, graphql } from "react-relay";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__54a9531d6ca6788b5c24;

function toggleContributionAnonymousMode(contribution, anonymous, onCompleted) {
  const variables = { contributionId: contribution.id, anonymous };

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted
  });
}

export { toggleContributionAnonymousMode };
